var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9281 -8164)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9281 8164)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14455.807 5923.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5192.9,2267.745q-4.912,0-9.826,0a1.281,1.281,0,0,1-1.418-1.416q0-8.467,0-16.935a1,1,0,0,1,1.123-1.117.95.95,0,0,1,.9.946c.009.181,0,.362,0,.543v15.342c0,.619,0,.619.6.619q9.205,0,18.41,0a1.094,1.094,0,0,1,1.179.627.987.987,0,0,1-.875,1.39c-.18.01-.361,0-.542,0Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5248.328,2310.791c-.7-.583-2.324-2.067-3.356-3.12-.229-.233-.362-.27-.616-.012q-1.242,1.256-2.54,2.455a.951.951,0,0,1-1.639-.458,1,1,0,0,1,.306-.994c1.125-1.145,2.254-2.286,3.4-3.4a1.068,1.068,0,0,1,1.648.1c.924.906,1.83,1.829,2.748,2.739.668.66.485.666,1.164-.007q2.593-2.572,5.177-5.149a1.037,1.037,0,1,1,1.456,1.438q-2.424,2.407-4.852,4.809c-.533.529-1.049,1.075-1.6,1.584A.834.834,0,0,1,5248.328,2310.791Z",
    transform: "translate(-53.944 -50.024)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQty);
export default __webpack_public_path__ + "static/media/icon-qty.022ad84d7aae0a183d8df0edf0bcbaf0.svg";
export { ForwardRef as ReactComponent };